import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { KalturaLogger } from '@kaltura-ng/kaltura-logger';
import { BrowserService } from 'app-shared/kmc-shell/providers/browser.service';
import { AppLocalization } from '@kaltura-ng/mc-shared';
import { Title } from '@angular/platform-browser';
import { ContextualHelpService } from 'app-shared/kmc-shared/contextual-help/contextual-help.service';
import { KmcMainViewBaseService, ViewMetadata } from '../kmc-main-view-base.service';
import { KMCPermissions, KMCPermissionsService } from '../../kmc-permissions';

@Injectable()
export class ContentCategoriesMainViewService extends KmcMainViewBaseService {
  constructor(
    logger: KalturaLogger,
    browserService: BrowserService,
    router: Router,
    private _appPermissions: KMCPermissionsService,
    appLocalization: AppLocalization,
    titleService: Title,
    contextualHelpService: ContextualHelpService,
  ) {
    super(
      appLocalization,
      logger.subLogger('ContentCategoriesMainViewService'),
      browserService,
      router,
      titleService,
      contextualHelpService,
    );
  }

  isAvailable(): boolean {
    return this._appPermissions.hasAnyPermissions([
      KMCPermissions.CONTENT_MANAGE_BASE,
      KMCPermissions.CONTENT_MANAGE_EDIT_CATEGORIES,
    ]);
  }

  getRoutePath(): string {
    return 'content/categories';
  }

  getViewMetadata(): ViewMetadata {
    return {
      viewKey: 'content-categories',
      title: this._appLocalization.get('app.titles.contentCategoriesPageTitle'),
      menu: this._appLocalization.get('app.titles.contentCategoriesMenuTitle'),
    };
  }
}
